import { render, staticRenderFns } from "./orderPay.vue?vue&type=template&id=6f028655&scoped=true&"
import script from "./orderPay.vue?vue&type=script&lang=js&"
export * from "./orderPay.vue?vue&type=script&lang=js&"
import style0 from "./orderPay.vue?vue&type=style&index=0&id=6f028655&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f028655",
  null
  
)

export default component.exports